module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-38.549b2aee.png";